import {FETCH_CONTACTUSDATA_BEGIN, FETCH_CONTACTUSDATA_SUCCESS, FETCH_CONTACTUSDATA_FAILURE}
from "../actions/contactUsPageActions";
  
  const initialState = {
    items: [],
    loading: false,
    error: null
  };
  
  export default function contactUsPageReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_CONTACTUSDATA_BEGIN:
        return {
          ...state,
          loading: true,
          error: null
        };
  
      case FETCH_CONTACTUSDATA_SUCCESS:
        return {
          ...state,
          loading: false,
          responseBody: action.totalResponse.contactUsResponse,
          items: action.payload.contactUsPageComponents
        };
  
      case FETCH_CONTACTUSDATA_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload.error,
          items: []
        };
  
      default:
        return state;
    }
  }
  